module.exports = __webpack_public_path__ + "img/code.31786305.svg";